export default "__VITE_PUBLIC_ASSET__618e40af__"